import { CallApi, handleJSONResponse } from './common';
import { ListSubscriptionsResponse } from '@common/types/subscription-manager/list-subscriptions-response';

const callAPI = CallApi('subscription-manager');

export const list = async (): Promise<ListSubscriptionsResponse> => {
  const response = await callAPI(`/`, 'GET');

  return handleJSONResponse(response);
};
